import ListOption from "../../ListOption";
import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {ContentQueryValueObject} from "../../../data/value-object/content/ContentQueryValueObject";
import {ContentQuerySearchOption} from "../../../data/search-option/content/ContentQuerySearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {ContentQueryIO} from "../../../io/ContentIO";
import {ContentQueryDescription} from "../../../data/description/content/ContentQueryDescription";
import {ContentQueryDescriptor} from "../../../data/descriptor/content/ContentQueryDescriptor";
import {
    ContentQuerySearchOptionDescription
} from "../../../data/description/content/ContentQuerySearchOptionDescription";
import {
    applyContentQuerySearchOption,
    ContentQuerySearchOptionField
} from "../../search-option-field/content/ContentQuerySearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<ContentQueryValueObject[]>([])
    const option = useStatePair<ContentQuerySearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={ContentQueryIO}
                items={items}
                option={option.value}
                index={index}
                description={ContentQueryDescription}
                descriptor={ContentQueryDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/contents/queries/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={ContentQuerySearchOptionDescription}
                fields={ContentQuerySearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyContentQuerySearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={ContentQueryDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}